import React, { useState, useEffect } from 'react'
import { Link, useLocation,useHistory } from 'react-router-dom';
import { getList } from '../helpers/api_helper';

export default function PopularBox() {

     var history = useHistory();
    const [data, setData] = useState([]);



    useEffect(() => {
        getListingjob();
    }, []);

    const getListingjob = () => {
        getList('/meta/pop').then((json) => {
            if (json.statusCode == 200) {
                setData(json?.data);
                console.log('meta pop', json)
            }

        })

    }

const industryFunction = (id) =>{

    history.push('/job-listing', { state: {indId:id} });
}

const locationFunction = (item) =>{
    history.push('/job-listing', { state: {city:item} });
}

    return (

        <>
            <div className="container bg_white">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title text-center">

                            <h1 className="title-heading">Popular Location</h1>
                            <div className="desc">
                                <p>Top apprentice positions available in many locations and disciplines</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-gutter-20 justify-content-center">
                    {
                        data?.location?.map((item, index) => {
                            return (
                                <div className="col-sm-6 col-lg-3">

                                    <div className="job-category-item">
                                        <div className="content">
                                            <h3 className="title"><a href="javascript:void(0);" onClick={()=>locationFunction(item?.city)}>{item?.city}, {item?.state} <span>({item?.count})</span></a></h3>
                                        </div>

                                    </div>

                                </div>
                            )
                        })
                    }

                </div>
            </div>
            <div className='bg_gray'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title text-center">
                            <h1 className="title-heading">Popular Industry</h1>
                                <div className="desc">
                                    <p>Browse top apprentice positions by different industries</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-gutter-20 justify-content-center">

                    {
                        data?.industry?.map((item, index) => {
                            return (
                                <div className="col-sm-6 col-lg-3">

                                    <div className="job-category-item">
                                        <div className="content">
                                            <h3 className="title"><a href="javascript:void(0);" onClick={()=>industryFunction(item?._id)}>{item?.name} <span>({item?.count})</span></a></h3>
                                        </div>

                                    </div>

                                </div>
                            )
                        })
                    }
                    </div>
                </div>
            </div>
        </>

    )
}
